var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc. / Pin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6C11 7.65685 9.65685 9 8 9C6.34315 9 5 7.65685 5 6C5 4.34315 6.34315 3 8 3C9.65685 3 11 4.34315 11 6ZM9.5 6C9.5 6.82843 8.82843 7.5 8 7.5C7.17157 7.5 6.5 6.82843 6.5 6C6.5 5.17157 7.17157 4.5 8 4.5C8.82843 4.5 9.5 5.17157 9.5 6Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46456 14.3255C9.30702 14.5015 9.15003 14.6768 8.99449 14.8518C8.65297 15.2359 8.31838 15.6179 8 16C7.68162 15.6179 7.34703 15.2359 7.00551 14.8518C6.85001 14.6769 6.69307 14.5016 6.53557 14.3256C4.3229 11.8537 2 9.25859 2 6C2 2 5 0 8 0C11 0 14 2 14 6C14 9.25859 11.6772 11.8535 9.46456 14.3255ZM12.5 6C12.5 7.54147 11.8307 8.97891 10.7264 10.49C10.1765 11.2424 9.54381 11.98 8.87044 12.7385C8.70415 12.9259 8.53387 13.1161 8.36181 13.3083C8.24196 13.4422 8.12082 13.5775 8 13.713C7.87904 13.5774 7.75818 13.4423 7.63819 13.3083C7.46613 13.1161 7.29585 12.9259 7.12956 12.7385C6.45619 11.98 5.82346 11.2424 5.27359 10.49C4.16934 8.97891 3.5 7.54147 3.5 6C3.5 4.40704 4.08245 3.32253 4.87155 2.62111C5.68825 1.89515 6.81961 1.5 8 1.5C9.18039 1.5 10.3117 1.89515 11.1285 2.62111C11.9176 3.32253 12.5 4.40704 12.5 6Z",
    fill: "#323232"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.030fb6a266d96fbf9a21112859da5057.svg";
export { ForwardRef as ReactComponent };